import React from "react";
import {withTranslation } from "react-i18next";
class Errorboundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    render() {
        const { t } = this.props;
        if (this.state.hasError) {
            return <h1>{t('something_went_wrong')}. . .</h1>;
        }

        return this.props.children;
    }
}
export default withTranslation()(Errorboundary);